/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import ptBr from 'date-fns/locale/pt-BR';
import { withTranslation } from 'react-i18next';
import { scrollToTop } from '../../utils/smartutils';

const DateField = ({
  t,
  input,
  placeholder,
  minDate,
  maxDate,
  minTime,
  maxTime,
  showMonthDropdown,
  showYearDropdown,
  showInline,
  showTimeSelect,
  showTimeSelectOnly,
  isTimeSelect,
  selected,
  showTimeInput,
  isTimeInput,
  disabled,
  meta,
  excludeDates,
  filterDate,
  isClearable,
}) => {
  const [message, setMessage] = useState(null);
  const dateFieldValidation = () => {
    if (meta.error) {
      setMessage(meta.error);
    }
    return null;
  };

  return (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
      <div className="date-field">
        <DatePicker
          disabled={disabled}
          showPopperArrow={false}
          dateFormat={isTimeSelect || isTimeInput ? 'HH:mm' : 'dd/MM/yyyy'}
          timeIntervals={30}
          locale={ptBr}
          selected={input.value || selected}
          onChange={input.onChange}
          minDate={minDate}
          maxDate={maxDate}
          minTime={minTime}
          maxTime={maxTime}
          disabledKeyboardNavigation
          placeholderText={placeholder}
          showMonthDropdown={showMonthDropdown}
          showYearDropdown={showYearDropdown}
          dropdownMode="scroll"
          timeCaption={t('general.hour')}
          inline={showInline}
          showTimeSelect={showTimeSelect}
          showTimeSelectOnly={showTimeSelectOnly}
          showTimeInput={showTimeInput}
          timeInputLabel={t('general.hour')}
          excludeDates={excludeDates}
          filterDate={filterDate}
          isClearable={isClearable}
          onBlur={dateFieldValidation}
        />
      </div>
      {message && <span className="form__form-group-error">{meta.error}</span>}
      {meta.submitFailed && meta.error && (
        <span className="form__form-group-error">
          {meta.error}
          {scrollToTop()}
        </span>
      )}
    </div>
  );
};

DateField.defaultProps = {
  showInline: false,
  showTimeSelect: false,
  showTimeSelectOnly: false,
  isTimeSelect: false,
  isTimeInput: false,
  selected: null,
  showTimeInput: null,
  disabled: false,
  excludeDates: [],
  filterDate: null,
  isClearable: false,
};

export default withTranslation('common')(DateField);
